import {AppRouterInstance} from 'next/dist/shared/lib/app-router-context.shared-runtime';

const isHttpsUrl = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === 'https:';
  } catch (error) {
    return false;
  }
};

export const navigate = (router: AppRouterInstance, url: string) => {
  const queryParams = new URLSearchParams(url.split('?')[1] || '');
  const urlParam = queryParams.get('url');
  // const urlParam = url.searchParams.get('url');
  if (urlParam) {
    if (isHttpsUrl(urlParam)) {
      router.push(url);
    } else {
      router.push('/en/404');
    }
  } else {
    router.push(url);
  }
};

export function sanitizeRoute(route: string): string {
  // Allow only alphanumeric characters, hyphens, underscores, and slashes
  return route.replace(/[^a-zA-Z0-9\-\/_]/g, '');
}

export function validateRoute(route: string): boolean {
  // Define a regex pattern that matches the expected route format
  // Example pattern: "/pagename/pageid", where pagename and pageid are alphanumeric, hyphen, or underscore
  const routePattern = /^\/[a-zA-Z0-9\-_]+(\/[a-zA-Z0-9\-_]+)*$/;
  return routePattern.test(route);
}

export function preventPathTraversal(route: string): boolean {
  // Check for path traversal patterns
  return !route.includes('..') && !route.includes('~');
}
